module.exports = __webpack_public_path__ + "assets/images/lasso-logo-default.png";